import type { UserPreferencesNotificationsTableColumnHeaderProps } from "./user-preferences-notifications-table-column-header.type";

import { Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { UserPreferencesNotificationsDropdown } from "../user-preferences-notifications-dropdown";

import { useUserPreferencesNotificationsTableColumnHeader } from "./user-preferences-notifications-table-column-header.hook";

const { Text } = Typography;

export const UserPreferencesNotificationsTableColumnHeader = (
  props: UserPreferencesNotificationsTableColumnHeaderProps
) => {
  const { t } = useTranslation();

  const { channel, menuItems, onMenuItemClick } =
    useUserPreferencesNotificationsTableColumnHeader(props);

  return (
    <Flex align="center" gap="small">
      <Text>{t(`user:preferences.notifications.channels.${channel}`)}</Text>
      <UserPreferencesNotificationsDropdown
        menuItems={menuItems}
        onMenuItemClick={onMenuItemClick}
        type="text"
        shape="circle"
      />
    </Flex>
  );
};
